import "./Home.css";
import studio from "../assets/studioThreeQuarterMedRes.webp";
import { useRef, useEffect, useState } from 'react';
import PulsingChevrons from "../components/PulsingChevrons";

function Home() {
  const landingRef = useRef(null);
  const nextSectionRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (landingRef.current && nextSectionRef.current) {
        const nextSectionRect = nextSectionRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        // Calculate when the top of the next section reaches 50% of the viewport height
        const triggerPoint = viewportHeight * 0.7;

        // Calculate the scroll progress of the next section entering the viewport
        if (nextSectionRect.top <= triggerPoint) {
          const progress = Math.min(1, Math.max(0, (triggerPoint - nextSectionRect.top) / (nextSectionRect.height * 0.5))); // Adjust 0.5 for sensitivity
          setScrollProgress(progress);
        } else {
          setScrollProgress(0);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Calculate opacity (fading out as scrollProgress increases)
  const landingOpacity = Math.max(0, 1 - scrollProgress * 2);

  // Calculate blur (increasing as scrollProgress increases)
  const blurAmount = Math.min(1, scrollProgress * 5) * 15;

  return (
    <>
      <div
        ref={landingRef}
        className="landing"
        style={{
          opacity: landingOpacity,
          filter: `blur(${blurAmount}px)`,
        }}
      >
        <div className="infoContainer">
          <div className="info1">threehalves</div>
          <div className="info2">superhumanoid general purpose robot</div>
          <PulsingChevrons x={50} y={200} vertical={true} color="black" size={200} />

          
        </div>
        <img src={studio} className="studio" alt="the threehalves robot, a 7 foot tall centaur form factor robot with a goat head"></img>
      </div>
      <div ref={nextSectionRef} className="next-section">
      </div>
    </>
  );
}

export default Home;